import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import { RootState } from 'src/configs/store';
import RouterRedirect from '../RouterRedirect/RouterRedirect';
import GuardRoute from '../GuardRoute/GuardRoute';
import TradingPage from '../Page/TradingPage';
import Page from 'src/containers/Page/Page';
import NextRaces from 'src/pages/NextRaces/NextRaces';
import RacingDetail from 'src/pages/RacingDetail/RacingDetail';
import Login from 'src/pages/Login/Login';
import TradingHome from 'src/pages/TradingHome/TradingHome';
import AddMeeting from 'src/pages/AddMeeting/AddMeeting';

export default function TradingRouting() {
  const { tradingUser } = useSelector((state: RootState) => state.auth);

  return (
    <>
      {
        _.isNull(tradingUser)
          ? (
            <Route render={ () => <Login /> } />
          )
          : (
            <Switch>
              { /* RACING */ }
              <Route
                exact
                path="/"
                render={ () => <TradingHome /> }
              />
              <Route exact path="/racing">
                <RouterRedirect to="/racing/today" />
              </Route>
              <Route
                exact
                path="/racing/next-races"
                render={ () => <NextRaces /> }
              />
              <Route
                exact
                path="/racing/:type"
                render={ routeProps => <Page { ...routeProps } childComponent="HorseBetting" /> }
              />
              <GuardRoute
                exact
                path={ ['/racing/:meetingCode/:event', '/racing/:meetingCode/:event/:tab', '/racing/:meetingCode/:event/:tab/:market'] }
                render={ () => <RacingDetail /> }
              />
              <GuardRoute
                exact
                path="/add-meeting"
                render={ (routeProps) => <TradingPage { ...routeProps } ><AddMeeting /></TradingPage> }
              />

              <Route path="*">
                <TradingHome />
                { /* Temp fix until we have a layout on TradingHome */ }
                <RouterRedirect to="/racing" />
              </Route>
            </Switch>
          )
      }
    </>
  );
}
